import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    parametros_gerais: {},
    usuario_logado: {},
    foto_usuario_logado: undefined,

    parametros_adm_servicos: {},    
    empresa_logada: {},
    empresas_autorizadas: [],

    modulo_sistema_id: 0
  },

  getters: {
    getParametrosGerais: state => {
      return state.parametros_gerais
    },
    
    getDadosUsuarioLogado: state => {
      return state.usuario_logado
    },

    getFotoUsuarioLogado: state => {
      return state.foto_usuario_logado
    },

    getParametrosAdmServicos: state => {
      return state.parametros_adm_servicos
    },

    getEmpresaLogada: state => {
      return state.empresa_logada
    },

    getEmpresasAutorizadas: state => {
      return state.empresas_autorizadas
    },

    getModuloSIstemaId: state => {
      return state.modulo_sistema_id
    }
  },
  
  mutations: {
    'LIMPAR_SESSAO' (store, dados) {
      store.parametros_gerais = {};
      store.usuario_logado = {};
      store.foto_usuario_logado = undefined;
      store.parametros_adm_servicos = {};
      store.empresa_logada = {};
      store.empresas_autorizadas = [];
      store.modulo_sistema_id = 0;
    },

    'SET_PARAMETROS_GERAIS' (store, dados) {
      store.parametros_gerais = JSON.parse(JSON.stringify(dados));
    },
      
    'SET_USUARIO_LOGADO' (store, dados) {
      store.usuario_logado = JSON.parse(JSON.stringify(dados));
    },

    'SET_FOTO_USUARIO_LOGADO' (store, dados) {
      store.foto_usuario_logado = dados;
    },
  
    'SET_PARAMETROS_ADM_SERVICOS' (store, dados) {
      store.parametros_adm_servicos = JSON.parse(JSON.stringify(dados));
    },

    'SET_EMPRESA_LOGADA' (store, dados) {
      store.empresa_logada = JSON.parse(JSON.stringify(dados));
    },

    'SET_EMPRESAS_AUTORIZADAS' (store, dados) {
      store.empresas_autorizadas = JSON.parse(JSON.stringify(dados));
    },
    
    'SET_MODULO_SISTEMA_ID' (store, dados){
      store.modulo_sistema_id = dados;
    },

    'SET_PARAMETROS_EMPRESA' (store, dados) {
      store.parametros_empresa = JSON.parse(JSON.stringify(dados));
    },

    'SET_AUTORIZACOES' (store, dados) {
      store.autorizacoes = JSON.parse(JSON.stringify(dados));
    },
  }  
})


// WEBPACK FOOTER //
// ./src/ambiente/store.js